import React from 'react';
import ChecklistItem from '../ChecklistItem';
import {
    TodoItemWrapper
} from '../../styles/TodoList.styles';

const TodoItem = ({
    todo,
    index,
    onToggle,
    onDelete,
    onUpdate,
    onConvert,
    showConvert,
    isParentCollapsed,
    }) => (
        <TodoItemWrapper>
            <ChecklistItem
                item={todo}
                index={index}
                onToggle={onToggle}
                onDelete={onDelete}
                onUpdate={onUpdate}
                onConvert={onConvert}
                // Pass isParentCollapsed, or derive an isExpanded prop
                // For clarity, let's derive isExpanded
                isExpanded={!isParentCollapsed}
            />
    </TodoItemWrapper>
);

export default TodoItem;